// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"2":"patient","123":"case","430":"doctor","594":"about","857":"report"}[chunkId] + "." + {"2":"07adc5c5","123":"7d085a58","430":"47a2f483","594":"51708183","857":"ecb9b983"}[chunkId] + ".js";
};